import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 text-center">
      <div>
        <h1 className="display-4 mb-4">
          404 <span className="text-danger">Page Not Found</span>
        </h1>
        <p className="mb-4 text-secondary">Ooh NO! You're on the wrong page.</p>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/')}
        >
          Back to Home Page
        </button>
      </div>
    </div>
  );
};

export default NotFound;
